/**
 * A line's reference as a customer reads it: "01", never ".01" or
 * "ORD-K48312.01" (Ben, 5 Oct: every customer-facing page, email, PDF and
 * row label). Staff surfaces keep the full ref.
 */
export function customerLineRef(ref: string): string {
  const dot = ref.lastIndexOf(".");
  return dot >= 0 ? ref.slice(dot + 1) : ref;
}
